<template>
    <div>
        <div class="modal fade" id="payment" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true"
            data-bs-backdrop="true" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-lg modal-dialog-centered">
                <div class="modal-content exo-2" style="border-radius: 20px;" :style="skin.header_desktop.nav_bar">
                    <button id="closeLoginP" :style="skin.my_account.close_btn" style="display: block;margin: 0%;"
                        type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                    <h3 class="modal-title title text-center mb-2 p-1" id="exampleModalLabel">{{ translate('DEPOSIT') }}
                    </h3>
                    <div class="modal-body p-1 m-2">
                        <div class="text-center">
                            <!-- <div class="text-center" style="font-size: 12px; color: lightgray;">
                                {{ translate('Click here to view the ') }}
                                <a :href="transactionFeesUrl" target="_blank"
                                    style="color: lightblue; text-decoration: underline;">
                                    {{ translate('Transaction Fees') }}
                                </a>
                            </div> -->
                            <!-- Selección de moneda -->
                            <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                <select v-model="selectedMethod" class="form-control input-login mr-sm-2 my-sm-0">
                                    <option disabled value="">{{ translate('choose_method') }}</option>
                                    <option v-for="method in methods" :key="method" :value="method">
                                        {{ method }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="selectedMethod == 'CRIPTO'">
                                <form @submit.prevent="payment" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedCurrency" @change="handleCurrencyChange"
                                            class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('choose_currency') }}</option>
                                            <option v-for="currency in currencies" :key="currency" :value="currency">
                                                {{ currency }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100"> 
                                    <input v-model="destinationTag"  type="text" :placeholder="translate('destinationTag (optional)')" class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                </div> -->
                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;"
                                            :disabled="login_inProcess || !selectedCurrency">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Get Address') }}
                                            </span> </button>
                                    </div>
                                    <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong>
                                </form>
                                <!-- Mostrar datos de pago si están disponibles -->
                                <div v-if="paymentData" class="payment-info mb-2 my-1">

                                    <div class="text-center mb-3">
                                        <!-- Código QR -->
                                        <img :src="paymentData.qrCode" alt="QR Code"
                                            style="max-width: 150px; margin: 0 auto;" />
                                    </div>

                                    <!-- Detalles de pago -->
                                    <div class="payment-details mb-3" style="color: aliceblue; font-size: 15px;">
                                        <div class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('Wallet') }}:</strong> {{ paymentData.address
                                            }}</span>
                                            <button @click="copyToClipboard(paymentData.address)" class="btn btn-sm"
                                                style="margin-left: 10px; color: aliceblue;">
                                                <i class="fas fa-copy"></i> {{ translate('copy') }}
                                            </button>
                                        </div>
                                        <div v-if="paymentData.destinationTag != null"
                                            class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('Destination Tag') }}:</strong> {{
                                                paymentData.destinationTag }}</span>
                                            <button @click="copyToClipboard(paymentData.destinationTag)"
                                                class="btn btn-sm" style="margin-left: 10px; color: aliceblue;">
                                                <i class="fas fa-copy"></i> {{ translate('copy') }}
                                            </button>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('Expiration date') }}:</strong> {{
                                                formattedExpDate }}</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('Rate') }}:</strong> 1 {{
                                                paymentDataForm.Currency }} = {{ paymentData.rate }} USD</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('Minimum amount') }}:</strong> {{
                                                paymentData.minimumAmount }} {{ paymentDataForm.Currency }}</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center mb-2">
                                            <span><strong>{{ translate('network Fee') }}:</strong> {{
                                                Coin.networkFee }} {{ paymentDataForm.Currency }}</span>
                                        </div>
                                        <div :class="'alert alert-' + status.type" role="alert"
                                            style="color: aliceblue; font-size: 15px;">When the transaction is
                                            processed, the balance will be reflected immediately.</div>

                                    </div>

                                    <!-- Botón Confirmar -->
                                    <!-- <div class="text-center mt-4">
    <button class="btn btn-success btn-lg">{{ translate('confirm') }}</button>
</div> -->
                                </div>

                                <div v-if="paymentDataForm?.error" :class="'m-0 p-0 alert alert-' + status.type"
                                    role="alert" class="m-0 p-0">{{ paymentDataForm.error }}
                                </div>
                            </div>
                            <div v-if="selectedMethod == 'CREDIT CARD'">
                                <form @submit.prevent="payment_card" class="p-1 my-3">
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN USD</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="1" min="0.01"
                                            :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">{{ translate('country') }}</h4>
                                    <div v-if="skin.register_fields.country"
                                        class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select class="form-control input-login mr-sm-2 my-sm-0" name="country"
                                            v-model="slectedCountry" id="registerCountry" required>
                                            <option v-for="(country, index) in countries()" :key="index"
                                                :value="country.iso_3">{{ language == "es" ? country.name_es :
                                                    country.name_en }}</option>
                                        </select>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail"  type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName"  type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>

                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="login_inProcess">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Do Payment') }}
                                            </span> </button>
                                    </div>
                                    <!-- <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong> -->
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'PIX'">
                                <form @submit.prevent="payment_pix" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <!-- <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedCard" @change="handleCurrencyChange"
                                            class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('choose_card') }}</option>
                                            <option v-for="card in cards" :key="card" :value="card">
                                                {{ card }}
                                            </option>
                                        </select>
                                    </div> -->
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN BRL</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="0.01"
                                            min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id"  type="number"
                                            :placeholder="translate('Identification Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName"  type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="last_name"  type="text"
                                            :placeholder="translate('Last Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail"  type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="login_inProcess">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Do Payment') }}
                                            </span> </button>
                                    </div>
                                    <!-- <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong> -->
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'CUENTA DE AHORROS'">
                                <form @submit.prevent="payment_quickly" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <h4 style="color: aliceblue; font-size: 12px;">ELIJA EL BANCO</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedBank" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Choose Bank') }}</option>
                                            <option v-for="bank in banks" :key="bank.name" :value="bank">
                                                {{ bank.descripcion }}
                                            </option>
                                        </select>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN COP</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="1" min="1"
                                            :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="usuTipdoc" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Document Type') }}</option>
                                            <option v-for="doc in docs" :key="doc" :value="doc">
                                                {{ doc }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id"  type="number"
                                            :placeholder="translate('Identification Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName"  type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="usuTelefono"  type="text"
                                            :placeholder="translate('Phone Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail"  type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="login_inProcess">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Do Payment') }}
                                            </span> </button>
                                    </div>
                                    <!-- <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong> -->
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'CRIPTO ARG'">
                                <form @submit.prevent="payment_cripto" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <!-- <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedCard" @change="handleCurrencyChange"
                                            class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('choose_card') }}</option>
                                            <option v-for="card in cards" :key="card" :value="card">
                                                {{ card }}
                                            </option>
                                        </select>
                                    </div> -->
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN ARS</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="0.01"
                                            min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="usuTelefono"  type="number"
                                            :placeholder="translate('Phone Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName"  type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="last_name"  type="text"
                                            :placeholder="translate('last Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail"  type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-0 align-content-center justify-content-center">
                                        <button id="submit_btnp" type="submit" class="btn p-0 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="login_inProcess">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Do Payment') }}
                                            </span> </button>
                                    </div>
                                    <!-- <strong style="color:darkgray;" class="mb-3">Use the code only for one transaction,
                                        to make another get a new address</strong> -->
                                </form>
                            </div>
                            <div v-if="getPaymentData2?.error" :class="'alert alert-' + status.type" class="p-0"
                                role="alert" style="color:brown; font-size: 15px;">{{ getPaymentData2.error }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { setTimeout } from 'core-js';
const countries = require('../../assets/countries.json');

export default {
    name: "payment",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            status: {
                message: "",
                type: ""
            },
            transactionFeesUrl: 'https://docs.0xprocessing.com/basic/general/transaction-fees', // URL para ver las Transaction Fees
            timeRemaining: "",
            cardEmail: 'alejo@ped.co',
            last_name: 'ped',
            "tax_id": "",
            usuTelefono: "1231231231",
            usuTipdoc: "CC",
            cardName: 'alejo',
            amount: 5.00,
            cardCVV: '123',
            cardYear: '08',
            cardMonth: '28',
            cardNumber: '1234123412341234',
            intervalId: null,
            login_inProcess: false,
            slectedCountry: '',
            selectedCurrency: '', // Moneda seleccionada
            selectedCard: '',
            destinationTag: '',
            loading: false,
            selectedBank: {},
            selectedMethod: 'CRIPTO ARG', // Moneda seleccionada
            methods: ['CRIPTO', 'CREDIT CARD', 'PIX', 'CUENTA DE AHORROS', 'CRIPTO ARG'],
            docs: ['CC', 'NIT'],
            currencies: [
                'BTC', 'LTC', 'DASH', 'DOGE', 'BCH', 'XRP', 'CSC', 'ETH', 'USDT (ERC20)', 'USDC (ERC20)', 'TUSD (ERC20)', 'DAI (ERC20)', 'AXS (ERC20)', 'WEVER (ERC20)', 'TRX (ERC20)',
                'TRX', 'USDT (TRC20)', 'AXS (TRC20)', 'ETH (TRC20)',
                'BNB', 'USDT (BEP20)', 'USDC (BEP20)', 'DAI (BEP20)', 'BTCB (BEP20)', 'ETH (BEP20)', 'ADA (BEP20)', 'DESU (BEP20)', 'MDAO (BEP20)',
                'AVAX', 'USDT (AVAXC)', 'TUSD (AVAXC)', 'USDC (AVAXC)',
                'MATIC', 'USDT (POLYGON)', 'USDC (POLYGON)', 'WETH (POLYGON)',
                'ETH (ARB1)', 'USDT (ARB1)', 'DAI (ARB1)', 'USDC (ARB1)', 'WBTC (ARB1)',
                'TON', 'USDT (TON)', 'NOT (TON)',
                'ETH (BASE)', 'USDC (BASE)'
            ], // Lista completa de monedas
            cards: [
                'VISA', 'MARTER CARD'
            ]
        }
    },
    computed: {
        // paymentMethods() {
        //     letthis.$props.skin.auto_payment.provider;
        // },
        formattedExpDate() {
            if (!this.paymentData || !this.paymentData.expDate) return '';
            const expDate = new Date(this.paymentData.expDate);
            return `${expDate.toLocaleDateString()} ${expDate.toLocaleTimeString()}`;
        },
        paymentData() {
            let data = this.$store.getters["getPayment"].paymentData
            // console.log(data)
            return data
        },
        Coin() {
            // console.log(this.$store.getters["getCoin_info"])
            return this.$store.getters["getCoin_info"]
        },
        paymentDataForm() {
            return this.$store.getters["getPaymentData"]
        },
        banks() {
            // console.log(this.$store.getters["getQuicklyPayBanks"])
            return this.$store.getters["getQuicklyPayBanks"]
        },
        getPaymentData2() {
            // console.log(this.$store.getters["getPayment"])
            let data = this.$store.getters["getPayment"].withdrawalData != undefined ? this.$store.getters["getPayment"].withdrawalData != undefined : this.$store.getters["getPayment"]
            // console.log(data)
            return data
            // return this.$store.getters["getWithdraw"]

        },
    },
    methods: {
        async payment_card() {
            // console.log('credit_card')
            // console.log(this.slectedCountry)
            let data = { cardCVV: this.cardCVV, cardYear: this.cardYear, cardMonth: this.cardMonth, cardNumber: this.cardNumber, cardName: this.cardName, cardEmail: this.cardEmail, amount: this.amount, paymentMethod: 'credit_card', country: this.slectedCountry }
            // if (!this.selectedCurrency) {
            //     this.status.message = this.translate("choose_currency");
            //     this.status.type = "danger";
            //     return;
            // }
            this.loading = true;
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('set88paydata', data);
            // this.$store.commit("getPayment", {});
            setTimeout(async () => {
                await this.$store.dispatch("get88Payment");
                this.loading = false;
            }, 500);
        },
        async payment_pix() {
            // console.log('credit_card')
            // console.log(this.slectedCountry)
            let data = { tax_id: this.tax_id, email: this.cardEmail, first_name: this.cardName, last_name: this.last_name }
            // if (!this.selectedCurrency) {
            //     this.status.message = this.translate("choose_currency");
            //     this.status.type = "danger";
            //     return;
            // }
            this.loading = true;
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setPixdata', { data, amount: this.amount });
            // this.$store.commit("getPayment", {});
            setTimeout(async () => {
                await this.$store.dispatch("getPixPayment");
                this.loading = false;
            }, 500);
        },
        async payment_cripto() {
            // console.log('credit_card')
            // console.log(this.slectedCountry)
            let data = { phoneNumber: '+'+this.usuTelefono, email: this.cardEmail, firstName: this.cardName,"countryTax": "ES", lastName: this.last_name}
            // if (!this.selectedCurrency) {
            //     this.status.message = this.translate("choose_currency");
            //     this.status.type = "danger";
            //     return;
            // }
            this.loading = true;
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setCriptodata', { data, amount: this.amount });
            // this.$store.commit("getPayment", {});
            setTimeout(async () => {
                await this.$store.dispatch("getCriptoPayment");
                this.loading = false;
            }, 500);
        },
        async payment_quickly() {

            let data = { usuDoc: this.tax_id, usuCorreo: this.cardEmail, usuNombre: this.cardName, usuTipdoc: this.usuTipdoc, usuTelefono: this.usuTelefono, bank: this.selectedBank.bank, valor: this.amount.toString() }
            this.loading = true;
            // console.log(data)
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setQuicklydata', data);
            setTimeout(async () => {
                await this.$store.dispatch("getQuicklyPayment");
                this.loading = false;
            }, 500);
        },
        countries() {
            let country_list = [];
            countries.countries.forEach(country => {
                country_list.push(country);
            })
            return country_list.sort((a, b) => (a[this.$props.language == "es" ? "name_es" : "name_en"] > b[this.$props.language == "es" ? "name_es" : "name_en"]) ? 1 : -1)
        },
        async payment() {
            if (!this.selectedCurrency) {
                this.status.message = this.translate("choose_currency");
                this.status.type = "danger";
                return;
            }
            this.loading = true;
            // Lógica de envío a la store de Vuex
            this.$store.commit("getPayment", {});
            await this.$store.dispatch('setCurrency', { Currency: this.selectedCurrency, DestinationTag: this.destinationTag });
            setTimeout(async () => {
                await this.$store.dispatch("getPayment");
                this.loading = false;
            }, 200);
        },
        async handleCurrencyChange() {
            // await this.$store.dispatch('setCurrency', { Currency: this.selectedCurrency, DestinationTag: this.destinationTag });
        },
        translate(text) {
            if (text) {
                const translatedText = this.$props.translation[text] || this.$props.translation[text.replace(/ /g, "_")];
                return translatedText ? translatedText[this.$props.language] : text;
            }
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.status = { message: this.translate("copied_to_clipboard"), type: "success" };
            });
        },
        startCountdown(expDate) {
            clearInterval(this.intervalId);

            this.intervalId = setInterval(() => {
                const now = new Date();
                const remainingTime = expDate - now;

                if (remainingTime <= 0) {
                    clearInterval(this.intervalId);
                    this.timeRemaining = this.translate("expired");
                } else {
                    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
                    this.timeRemaining = `${minutes}m ${seconds}s`;
                }
            }, 1000);
        }
    }
}
</script>


<style scoped>
.title {
    font-family: "Exo 2", sans-serif;
    color: #ebebd3 !important;
    height: 10px !important;
    font-size: 1rem !important;
    font-weight: bold;
    margin-bottom: 2px;
    margin: 0.5rem auto;
}

.login-btn {
    font-family: "Exo 2", sans-serif;
    color: black !important;
    font-size: small !important;
    font-weight: bold;
    margin-bottom: 12px;
    margin: 1rem auto;
}

.exo-2> {
    font-family: "Exo 2", sans-serif !important;
}

.input-login {
    background-color: #020f1d;
    font-family: "Exo 2", sans-serif;
    border: none;
    color: #fff;
    font-size: medium;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
}

.modal-fade {
    border-radius: 10px 10px 10px 10px;
}

.modal-title {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: 0.15rem !important;
    margin-bottom: 0 !important;
    height: 10px;
    padding: 0.5rem !important;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}

.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.login-user-control {
    color: #fff;
    width: 200%;
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 auto;
    /* Alinear horizontalmente */
    padding: 0.6rem 0 0.6rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}

.modal-title {
    height: 50px;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}

.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .8;
}

.login-user-control,
.submit_btn {
    text-align: center;
    color: #fff;
    width: 100%;
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0;
    /* Alinear horizontalmente */
    padding: 0.5rem 8rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}
</style>
